import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_username');
      if (window.location.pathname.startsWith('/admin/dashboard')) {
        window.location.href = '/admin';
      }
    }
    return Promise.reject(error);
  }
);

// Auth APIs
export const checkAdminExists = () => api.get('/admin/check');
export const adminLogin = (data) => api.post('/admin/login', data);
export const adminSetup = (data) => api.post('/admin/setup', data);
export const getAdminMe = () => api.get('/admin/me');

// Services APIs
export const getServices = () => api.get('/services');
export const createService = (data) => api.post('/services', data);
export const updateService = (id, data) => api.put(`/services/${id}`, data);
export const deleteService = (id) => api.delete(`/services/${id}`);

// Gallery APIs
export const getGallery = () => api.get('/gallery');
export const createGalleryItem = (formData) => api.post('/gallery', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const updateGalleryItem = (id, data) => api.put(`/gallery/${id}`, data);
export const deleteGalleryItem = (id) => api.delete(`/gallery/${id}`);

// Settings APIs
export const getSettings = () => api.get('/settings');
export const updateSettings = (data) => api.put('/settings', data);

// Quote APIs
export const getQuotes = () => api.get('/quotes');
export const createQuote = (data) => api.post('/quotes', data);
export const markQuoteRead = (id) => api.put(`/quotes/${id}/read`);
export const deleteQuote = (id) => api.delete(`/quotes/${id}`);

// Stats API
export const getStats = () => api.get('/stats');

// Seed API
export const seedData = () => api.post('/seed');

// Recent Works APIs
export const getRecentWorks = () => api.get('/recent-works');
export const createRecentWork = (formData) => api.post('/recent-works', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const updateRecentWork = (id, data) => api.put(`/recent-works/${id}`, data);
export const deleteRecentWork = (id) => api.delete(`/recent-works/${id}`);

// Upload API
export const uploadFile = (formData) => api.post('/upload', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});

export default api;
